import type { IconSvgObject } from './types';

const MpFour02Icon: IconSvgObject = [
  ["path", { d: "M19 22H5C3.89543 22 3 21.1046 3 20L3 4C3 2.89543 3.89543 2 5 2H12L19 9V11M18.5 9H13.998C12.8935 9 11.998 8.10457 11.998 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 14V16.5H21M21 16.5V14M21 16.5V19M7 19V14L9 17L11 14V19M13 19V17M13 17V14H14.5C15.3284 14 16 14.6716 16 15.5C16 16.3284 15.3284 17 14.5 17H13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MpFour02Icon;
